import {
    isRejectedWithValue,
    Middleware,
    MiddlewareAPI,
} from '@reduxjs/toolkit';
import { sendToSentry } from '@utils/sentry';

export const sendErrorToSentryMiddleware: Middleware =
    (_api: MiddlewareAPI) => next => action => {
        if (isRejectedWithValue(action)) {
            const isQuery = (action as any).meta?.arg?.type === 'query';
            if (isQuery) {
                const response = (action as any).meta.baseQueryMeta.response;

                sendToSentry('GetRequestError', `${response.url}`, {
                    action: action,
                });
            }
        }

        return next(action);
    };
